const apiKeys = {
  headerButtons: {
    create: 'Crear',
  },
  table: {
    headers: {
      alias: 'Nombre',
      createdAt: 'Creado el',
      accessTokenExpiration: 'Expiración de sesión',
      permissions: 'Permisos',
      editable: 'Editable',
    },
    actions: {
      delete: 'Eliminar',
      generateToken: 'Generar token',
    },
    expiration: {
      default: 'Predeterminado',
    },
    filters: {
      editable: {
        label: 'Editable',
        isEditable: 'Editable',
        isNotEditable: 'No editable',
      },
    },
    permissions: {
      all: 'Acceso total',
    },
    editable: {
      yes: 'Sí',
      no: 'No',
    },
  },
  create: {
    title: 'Crear clave de API',
    error: 'No se pudo crear la clave de API',
    unlimitedWarning: 'Los tokens sin límite permanecen activos hasta ser eliminados. Recomendamos establecer un período de expiración.',
    tabs: {
      info: 'Información',
      permissions: 'Permisos',
    },
    expirationUnits: {
      minutes: 'Minutos',
      hours: 'Horas',
      days: 'Días',
      unlimited: 'Sin límite',
    },
    fields: {
      alias: 'Nombre',
      expiresAt: 'Expiración de sesión',
    },
  },
  newSecretModal: {
    title: 'Nueva clave secreta',
    subtitle: 'Copie la clave secreta al portapapeles y guárdela en un lugar seguro.',
    warning: 'Tenga en cuenta: Una vez que cierre la ventana, no podrá volver a ver esta clave secreta.',
    secretKeyLabel: 'Clave secreta',
    copy: 'Copiar',
    copySuccess: 'Copiado al portapapeles',
    copyError: 'No se pudo copiar',
    done: 'Listo',
  },
  delete: {
    success: 'Clave de API eliminada',
    error: 'No se pudo eliminar la clave de API',
    confirmModal: {
      title: 'Eliminar clave de API',
      body: '¿Está seguro de que desea eliminar "{{ alias }}"? Todos los tokens activos creados a partir de esta clave dejarán de funcionar de inmediato.',
      bodyMany:
        '¿Está seguro de que desea eliminar {{ count }} claves de API? Todos los tokens activos creados a partir de estas claves dejarán de funcionar de inmediato.',
      confirm: 'Eliminar',
    },
  },
  edit: {
    title: 'Editar "{{ alias }}"',
    success: 'Clave de API actualizada',
    error: 'No se pudo actualizar la clave de API',
  },
  generateToken: {
    title: 'Ingresar clave secreta - {{ alias }}',
    subTitle: 'Ingrese la clave secreta y haga clic en generar para crear un token y un código corto.',
    successTitle: 'Nuevo token de API y código corto',
    submit: 'Generar',
    cancel: 'Cancelar',
    done: 'Listo',
    copy: 'Copiar',
    copySuccess: 'Copiado al portapapeles',
    copyError: 'No se pudo copiar',
    error: 'No se pudo generar el token',
    instructions: 'Pegue su Client Secret almacenado para generar un nuevo token de acceso.',
    tokenWarning: 'Tenga en cuenta: Una vez que cierre la ventana, no podrá volver a ver este token.',
    shortCodeWarning: 'Tenga en cuenta: Una vez que cierre la ventana, no podrá volver a ver este código corto.',
    fields: {
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'Pegue su clave secreta',
      token: 'Token de acceso',
      shortCode: 'Código corto',
      expiration: 'Expiración',
      tokenInfo: 'Copie el token al portapapeles y guárdelo en un lugar seguro.',
      shortCodeInfo: 'Copie el código corto al portapapeles y guárdelo en un lugar seguro.',
    },
  },
};

export default apiKeys;
